import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { RectShadowMaterial } from "../../materials/RectShadowMaterial";

const CarShadow = ({
  width = 4,
  height = 1.5,
  opacity = 0.35,
  softness = 0.8,
  carRigidBodyRef,
}) => {
  const shadowRef = useRef();

  const aspect = useMemo(() => {
    // Вычисляем aspect ratio для правильной формы эллипса
    return [width / height, 1.0];
  }, [width, height]);

  const material = useMemo(
    () => new RectShadowMaterial(opacity, softness, aspect),
    [opacity, softness, aspect]
  );

  // Обновляем позицию тени напрямую через ref для производительности
  useFrame(() => {
    if (shadowRef.current && carRigidBodyRef?.current) {
      const translation = carRigidBodyRef.current.translation();
      shadowRef.current.position.set(
        translation.x,
        -0.98, // Фиксированная высота над поверхностью (Surface на y=-2, его верх на y=-1)
        translation.z
      );
    }
  });

  return (
    <mesh
      ref={shadowRef}
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, -0.98, 0]}
      renderOrder={-1}
    >
      <planeGeometry args={[width, height, 64, 64]} />
      <primitive object={material} attach="material" />
    </mesh>
  );
};

export default CarShadow;
